// extracted by mini-css-extract-plugin
export var header = "PageHeader-module--header--2feGK";
export var title = "PageHeader-module--title--1FkZU";